import { Pipe, PipeTransform } from '@angular/core';

const AMENITY_LABELS: Record<string, string> = {
  "common.amenity.elevator": "Elevator",
  "common.amenity.accessibleEntrance": "Accessible entrance",
  "common.amenity.assignedParkingSpaces": "Assigned parking spaces",
  "common.amenity.babysittingAfterSchool": "Babysitting/afterschool services",
  "common.amenity.bikeStorageLockers": "Bike storage lockers",
  "common.amenity.busPublicTransport": "Bus stop/Public transportation access",
  "common.amenity.businessCenter": "Business center",
  "common.amenity.cableOrSatelliteTv": "Cable or satellite TV",
  "common.amenity.usbChargingOutlets": "Charging outlets with USB ports",
  "common.amenity.childrensPlayroom": "Children's playroom",
  "common.amenity.closeToSchools": "Close to schools",
  "common.amenity.commonAreaWifi": "Common area Wi-Fi",
  "common.amenity.communityCenter": "Community center",
  "common.amenity.communityEventsClasses": "Community events and classes",
  "common.amenity.concierge": "Concierge",
  "common.amenity.coveredParking": "Covered parking",
  "common.amenity.dishwasherInUnit": "Dishwasher in unit",
  "common.amenity.dogPark": "Dog park",
  "common.amenity.dogWashingStation": "Dog washing station",
  "common.amenity.doorman": "Doorman",
  "common.amenity.doorstepRecyclingCollection": "Doorstep recycling collection",
  "common.amenity.electricCarChargingStations": "Electric car charging stations",
  "common.amenity.energyEfficientAppliances": "Energy-efficient appliances",
  "common.amenity.fireplace": "Fireplace",
  "common.amenity.garages": "Garages",
  "common.amenity.gatedAccess": "Gated access",
  "common.amenity.greenSpace": "Green space",
  "common.amenity.gymnasium": "Gymnasium",
  "common.amenity.hardwoodFloors": "Hardwood floors",
  "common.amenity.highEndCountertopsFinishes": "High-end countertops and finishes",
  "common.amenity.highEndKitchenAppliances": "High-end kitchen appliances",
  "common.amenity.highSpeedInternet": "High-speed internet",
  "common.amenity.intercommunicationDevice": "Intercom device",
  "common.amenity.jogWalkBikePath": "Jogging/walking/bike path or nearby access",
  "common.amenity.largeDogsAllowed": "Large dogs allowed",
  "common.amenity.laundryService": "Laundry service",
  "common.amenity.mediaRoom": "Media room",
  "common.amenity.multiplePetsAllowed": "Multiple pets allowed",
  "common.amenity.onSiteResidentManager": "On-site resident manager",
  "common.amenity.onlineLeasingRentMaintenance": "Online leasing, rent payment, and maintenance requests",
  "common.amenity.outdoorAreas": "Outdoor areas",
  "common.amenity.outdoorTerrace": "Outdoor terrace",
  "common.amenity.packageLockers": "Package lockers",
  "common.amenity.partyRoom": "Party room",
  "common.amenity.patioOrBalcony": "Patio or balcony",
  "common.amenity.pedestrianFriendlyWalkScore": "Pedestrian-friendly (Walk Score)",
  "common.amenity.petFriendly": "Pet-friendly",
  "common.amenity.playground": "Playground",
  "common.amenity.pool": "Pool",
  "common.amenity.recreationRoom": "Recreation room",
  "common.amenity.recyclingCenter": "Recycling center",
  "common.amenity.rooftopTerrace": "Rooftop terrace",
  "common.amenity.securityCameras": "Security cameras",
  "common.amenity.securityGuard": "Security guard",
  "common.amenity.seniorCenter": "Senior center",
  "common.amenity.sharedCarServices": "Shared car services",
  "common.amenity.sharedLaundryRoom": "Shared laundry room",
  "common.amenity.smartControlsHvac": "Smart controls for heating/cooling",
  "common.amenity.smokeFree": "Smoke-free",
  "common.amenity.smokingPermittedInUnits": "Smoking permitted in units",
  "common.amenity.spa": "Spa",
  "common.amenity.storage": "Storage",
  "common.amenity.valetTrash": "Valet trash",
  "common.amenity.virtualDoorman": "Virtual doorman",
  "common.amenity.inUnitWasherDryer": "In-unit washer and dryer",
  "common.amenity.yogaDanceStudio": "Yoga/dance studio",
  "common.amenity.airConditioning": "Air-conditioning",
};
const amenities = [
  { "amenityTypeId": 66, "amenityCategoryId": 9, "amenityTranslationKey": "common.amenity.elevator" },
  { "amenityTypeId": 67, "amenityCategoryId": 9, "amenityTranslationKey": "common.amenity.accessibleEntrance" },
  { "amenityTypeId": 8,  "amenityCategoryId": 2, "amenityTranslationKey": "common.amenity.assignedParkingSpaces" },
  { "amenityTypeId": 45, "amenityCategoryId": 7, "amenityTranslationKey": "common.amenity.babysittingAfterSchool" },
  { "amenityTypeId": 9,  "amenityCategoryId": 2, "amenityTranslationKey": "common.amenity.bikeStorageLockers" },
  { "amenityTypeId": 13, "amenityCategoryId": 2, "amenityTranslationKey": "common.amenity.busPublicTransport" },
  { "amenityTypeId": 47, "amenityCategoryId": 7, "amenityTranslationKey": "common.amenity.businessCenter" },
  { "amenityTypeId": 30, "amenityCategoryId": 6, "amenityTranslationKey": "common.amenity.cableOrSatelliteTv" },
  { "amenityTypeId": 26, "amenityCategoryId": 6, "amenityTranslationKey": "common.amenity.usbChargingOutlets" },
  { "amenityTypeId": 48, "amenityCategoryId": 7, "amenityTranslationKey": "common.amenity.childrensPlayroom" },
  { "amenityTypeId": 44, "amenityCategoryId": 7, "amenityTranslationKey": "common.amenity.closeToSchools" },
  { "amenityTypeId": 28, "amenityCategoryId": 6, "amenityTranslationKey": "common.amenity.commonAreaWifi" },
  { "amenityTypeId": 37, "amenityCategoryId": 7, "amenityTranslationKey": "common.amenity.communityCenter" },
  { "amenityTypeId": 40, "amenityCategoryId": 7, "amenityTranslationKey": "common.amenity.communityEventsClasses" },
  { "amenityTypeId": 61, "amenityCategoryId": 9, "amenityTranslationKey": "common.amenity.concierge" },
  { "amenityTypeId": 7,  "amenityCategoryId": 2, "amenityTranslationKey": "common.amenity.coveredParking" },
  { "amenityTypeId": 17, "amenityCategoryId": 4, "amenityTranslationKey": "common.amenity.dishwasherInUnit" },
  { "amenityTypeId": 2,  "amenityCategoryId": 1, "amenityTranslationKey": "common.amenity.dogPark" },
  { "amenityTypeId": 3,  "amenityCategoryId": 1, "amenityTranslationKey": "common.amenity.dogWashingStation" },
  { "amenityTypeId": 55, "amenityCategoryId": 9, "amenityTranslationKey": "common.amenity.doorman" },
  { "amenityTypeId": 59, "amenityCategoryId": 9, "amenityTranslationKey": "common.amenity.doorstepRecyclingCollection" },
  { "amenityTypeId": 11, "amenityCategoryId": 2, "amenityTranslationKey": "common.amenity.electricCarChargingStations" },
  { "amenityTypeId": 20, "amenityCategoryId": 4, "amenityTranslationKey": "common.amenity.energyEfficientAppliances" },
  { "amenityTypeId": 22, "amenityCategoryId": 4, "amenityTranslationKey": "common.amenity.fireplace" },
  { "amenityTypeId": 6,  "amenityCategoryId": 2, "amenityTranslationKey": "common.amenity.garages" },
  { "amenityTypeId": 56, "amenityCategoryId": 9, "amenityTranslationKey": "common.amenity.gatedAccess" },
  { "amenityTypeId": 62, "amenityCategoryId": 9, "amenityTranslationKey": "common.amenity.greenSpace" },
  { "amenityTypeId": 32, "amenityCategoryId": 7, "amenityTranslationKey": "common.amenity.gymnasium" },
  { "amenityTypeId": 24, "amenityCategoryId": 4, "amenityTranslationKey": "common.amenity.hardwoodFloors" },
  { "amenityTypeId": 19, "amenityCategoryId": 4, "amenityTranslationKey": "common.amenity.highEndCountertopsFinishes" },
  { "amenityTypeId": 18, "amenityCategoryId": 4, "amenityTranslationKey": "common.amenity.highEndKitchenAppliances" },
  { "amenityTypeId": 29, "amenityCategoryId": 6, "amenityTranslationKey": "common.amenity.highSpeedInternet" },
  { "amenityTypeId": 65, "amenityCategoryId": 9, "amenityTranslationKey": "common.amenity.intercommunicationDevice" },
  { "amenityTypeId": 42, "amenityCategoryId": 7, "amenityTranslationKey": "common.amenity.jogWalkBikePath" },
  { "amenityTypeId": 4,  "amenityCategoryId": 1, "amenityTranslationKey": "common.amenity.largeDogsAllowed" },
  { "amenityTypeId": 16, "amenityCategoryId": 3, "amenityTranslationKey": "common.amenity.laundryService" },
  { "amenityTypeId": 38, "amenityCategoryId": 7, "amenityTranslationKey": "common.amenity.mediaRoom" },
  { "amenityTypeId": 5,  "amenityCategoryId": 1, "amenityTranslationKey": "common.amenity.multiplePetsAllowed" },
  { "amenityTypeId": 60, "amenityCategoryId": 9, "amenityTranslationKey": "common.amenity.onSiteResidentManager" },
  { "amenityTypeId": 31, "amenityCategoryId": 6, "amenityTranslationKey": "common.amenity.onlineLeasingRentMaintenance" },
  { "amenityTypeId": 41, "amenityCategoryId": 7, "amenityTranslationKey": "common.amenity.outdoorAreas" },
  { "amenityTypeId": 50, "amenityCategoryId": 7, "amenityTranslationKey": "common.amenity.outdoorTerrace" },
  { "amenityTypeId": 63, "amenityCategoryId": 9, "amenityTranslationKey": "common.amenity.packageLockers" },
  { "amenityTypeId": 39, "amenityCategoryId": 7, "amenityTranslationKey": "common.amenity.partyRoom" },
  { "amenityTypeId": 23, "amenityCategoryId": 4, "amenityTranslationKey": "common.amenity.patioOrBalcony" },
  { "amenityTypeId": 12, "amenityCategoryId": 2, "amenityTranslationKey": "common.amenity.pedestrianFriendlyWalkScore" },
  { "amenityTypeId": 1,  "amenityCategoryId": 1, "amenityTranslationKey": "common.amenity.petFriendly" },
  { "amenityTypeId": 43, "amenityCategoryId": 7, "amenityTranslationKey": "common.amenity.playground" },
  { "amenityTypeId": 36, "amenityCategoryId": 7, "amenityTranslationKey": "common.amenity.playground" },
  { "amenityTypeId": 35, "amenityCategoryId": 7, "amenityTranslationKey": "common.amenity.pool" },
  { "amenityTypeId": 46, "amenityCategoryId": 7, "amenityTranslationKey": "common.amenity.recreationRoom" },
  { "amenityTypeId": 58, "amenityCategoryId": 9, "amenityTranslationKey": "common.amenity.recyclingCenter" },
  { "amenityTypeId": 51, "amenityCategoryId": 7, "amenityTranslationKey": "common.amenity.rooftopTerrace" },
  { "amenityTypeId": 53, "amenityCategoryId": 9, "amenityTranslationKey": "common.amenity.securityCameras" },
  { "amenityTypeId": 54, "amenityCategoryId": 9, "amenityTranslationKey": "common.amenity.securityGuard" },
  { "amenityTypeId": 49, "amenityCategoryId": 7, "amenityTranslationKey": "common.amenity.seniorCenter" },
  { "amenityTypeId": 10, "amenityCategoryId": 2, "amenityTranslationKey": "common.amenity.sharedCarServices" },
  { "amenityTypeId": 14, "amenityCategoryId": 3, "amenityTranslationKey": "common.amenity.sharedLaundryRoom" },
  { "amenityTypeId": 27, "amenityCategoryId": 6, "amenityTranslationKey": "common.amenity.smartControlsHvac" },
  { "amenityTypeId": 68, "amenityCategoryId": 9, "amenityTranslationKey": "common.amenity.smokeFree" },
  { "amenityTypeId": 69, "amenityCategoryId": 9, "amenityTranslationKey": "common.amenity.smokingPermittedInUnits" },
  { "amenityTypeId": 33, "amenityCategoryId": 7, "amenityTranslationKey": "common.amenity.spa" },
  { "amenityTypeId": 52, "amenityCategoryId": 9, "amenityTranslationKey": "common.amenity.storage" },
  { "amenityTypeId": 57, "amenityCategoryId": 9, "amenityTranslationKey": "common.amenity.valetTrash" },
  { "amenityTypeId": 64, "amenityCategoryId": 9, "amenityTranslationKey": "common.amenity.virtualDoorman" },
  { "amenityTypeId": 15, "amenityCategoryId": 3, "amenityTranslationKey": "common.amenity.inUnitWasherDryer" },
  { "amenityTypeId": 34, "amenityCategoryId": 7, "amenityTranslationKey": "common.amenity.yogaDanceStudio" },
  { "amenityTypeId": 21, "amenityCategoryId": 4, "amenityTranslationKey": "common.amenity.airConditioning" }
];

export const getAmenityLabel = (amenityId: number): string | undefined => {
  const amenity = amenities.find(a => a.amenityTypeId === amenityId);
  if (!amenity) {
    return undefined;
  }
  return AMENITY_LABELS[amenity.amenityTranslationKey];
};

@Pipe({
  name: 'amenityLabel',
  standalone: true
})
export class AmenityLabelPipe implements PipeTransform {
  transform(amenityId: number): string {
    const label = getAmenityLabel(amenityId);
    return label ?? '';
  }
}
